import React from 'react'
import { useDispatch } from 'react-redux'
import { MdFormatListBulleted } from 'react-icons/md'
import ControlButton from '../../../Buttons/ControlButton'

import { setChangelogBoxOpen } from '../../../../redux/actions/map.actions'

export default function DownloadPoints() {
  const dispatch = useDispatch()

  const onSetChangelogBoxBoxOpen = () => {
    dispatch(setChangelogBoxOpen(true))
  }

  return (
    <ControlButton
      icon={MdFormatListBulleted}
      onClick={onSetChangelogBoxBoxOpen}
      customClass="ol-changelog"
    ></ControlButton>
  )
}
